import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

//import { HomeAuthResolver } from './home-auth-resolver.service';
import { SharedModule } from '../../../shared.module';
// import { UscHomeModule } from '../usc-home/usc-home.module';

@NgModule({
  imports: [
    SharedModule,
    // UscHomeModule
  ],
  declarations: [
  ],
  providers: [
    //HomeAuthResolver
  ]
})

export class UscNavModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-nav/usc-nav.module.ts